var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ElButton',_vm._g(_vm._b({staticClass:"button"},'ElButton',_vm.$attrs,false),_vm.$listeners),[_vm._l((_vm.$slots),function(_,name){return _vm._t(name,null,{"slot":name})}),_c('span',{class:{ 'is-badge': _vm.badge }})],2)}
var staticRenderFns = []

export { render, staticRenderFns }